import * as React from 'react';

import { dataSourceIdsSelector } from 'src/selectors/datasourceIdsSelector';
import * as copy from 'src/templates/copy';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import {
  INVALID_NAME_MATCHER,
  NAME_STARTS_WITH_MATCHER,
} from 'src/utils/removeInvalidNameChars';

const useFindDataSource = () => {
  const dataSourceNames = useReduxSelector(dataSourceIdsSelector);
  return React.useCallback(
    (dataSourceName: string) =>
      dataSourceNames.find((item) => item === dataSourceName),
    [dataSourceNames]
  );
};

export const useValidateDataSourceName = () => {
  const findDataSourceNames = useFindDataSource();
  return React.useCallback(
    (name: string): string => {
      if (!name) {
        return copy.components.projectResourceDialog
          .projectDataSourceCreationPanel.name.required;
      }

      if (!name.match(NAME_STARTS_WITH_MATCHER)) {
        return copy.components.projectResourceDialog
          .projectDataSourceCreationPanel.name.startsWith;
      }
      const invalidChars = name.match(INVALID_NAME_MATCHER);
      if (invalidChars) {
        return copy.components.projectResourceDialog.projectDataSourceCreationPanel.name.characters(
          invalidChars
        );
      }

      if (findDataSourceNames(name)) {
        return copy.components.projectResourceDialog
          .projectDataSourceCreationPanel.name.unique;
      }

      return '';
    },
    [findDataSourceNames]
  );
};
